var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "actions" },
    [
      _vm.record.calcId !== null && _vm.record.calcId !== undefined
        ? _c("c-button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: "Перейти в сохраненный расчет",
                  placement: "top",
                },
                expression:
                  "{\n      container: '#app',\n      trigger: 'hover blur',\n      content: 'Перейти в сохраненный расчет',\n      placement: 'top',\n    }",
                modifiers: { html: true },
              },
            ],
            attrs: { size: "iconic", icon: "calculate" },
            on: {
              click: function ($event) {
                return _vm.openCalc(_vm.record.calcId)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }